import React, { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import style from './InnerHeadBar.module.css'
import NotificationICon from "../../assests/26. Notification.png"
import MessageICon from "../../assests/Inbox.png";
import { useNavigate, useLocation } from 'react-router-dom';
import ActiveCalendar from "../../assests/activeCalendar.png";
import ActiveWorkOut from "../../assests/ActiveWeightlifting-sport-exercise-gym (1).png";
import Coin from "../../assests/indian-rupee 1.png"
import Profile from "../../assests/Profile-PNG-File.png"
import BillingIcon from '../../assests/Billing.png'
import { GiHamburgerMenu } from "react-icons/gi";
import { MdArrowBack } from "react-icons/md";
import { BsSearch } from "react-icons/bs";
import { useDispatch } from 'react-redux';
import DashboardIcon from '../../assests/Dashboard.png'
import LearningIcon from '../../assests/Learning.png'
import PerformanceIcon from '../../assests/Performance.png'
import ProfileIcon from '../../assests/User.png'
import DunoLogo from '../../assests/duno_main_logo.png'
import { googleLogout } from "@react-oauth/google";
import { FiLogOut } from "react-icons/fi";
import { MdPerson, MdLogout, MdCardMembership } from "react-icons/md";
import { fetchUserDetails } from '../../Slices/UserSlice';
import { baseurl } from "../Url";
import { useSelector } from "react-redux";
import { useCommunitySearch } from '../Context/CommunitySearchContext';
import { IoNotificationsOutline } from "react-icons/io5";
import { logActivity } from "../../services/activityService";

const InnerHeadBar = ({ finished, timeRunning, setFinishPopup, onMenuToggle, dashboardMode, profileSlot }) => {
  const navigate = useNavigate();
  const location = useLocation()
  const popupRef = useRef(null);
  const { userDetails, status: userStatus, error: userError, sessionExpired } = useSelector((state) => state.user);
  const { searchTerm, setSearchTerm } = useCommunitySearch();
  const isCommunityPage = location.pathname === '/community';

  const UserName = localStorage.getItem("username");
  const OrgID = localStorage.getItem("ORGID");

  const [notificationPopUp, setNotificationPopUp] = useState(false);
  const [profilePopup, setProfilePopup] = useState(false)
  const [notificationList, setNotificationList] = useState([]);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [imageError, setImageError] = useState(false);
  const [profileCompleted, setProfileCompleted] = useState(null);
  const [goalCompleted, setGoalCompleted] = useState(null);
  const withImageBust = (url, ts = Date.now()) => {
    if (!url) return "";
    const normalizedUrl = String(url).trim();
    if (normalizedUrl.startsWith("data:")) return normalizedUrl;
    return `${normalizedUrl}${normalizedUrl.includes("?") ? "&" : "?"}t=${ts}`;
  };
  const resolveProfileImageSrc = () => {
    if (!profileImageUrl || imageError) return Profile;
    const normalizedUrl = String(profileImageUrl).trim();
    if (normalizedUrl.startsWith("data:")) return normalizedUrl;
    return `${normalizedUrl}${normalizedUrl.includes("?") ? "&" : "?"}uid=${UserID || ""}`;
  };

  useEffect(() => {
    try {
      const cached = JSON.parse(localStorage.getItem("completionSyncData") || "{}");
      if (cached.profile_completion !== undefined) setProfileCompleted(cached.profile_completion);
      if (cached.goals_completion !== undefined) setGoalCompleted(cached.goals_completion);
    } catch { }

    const handleCompletionUpdate = (event) => {
      const detail = event?.detail || {};
      if (detail.profile_completion !== undefined) setProfileCompleted(detail.profile_completion);
      if (detail.goals_completion !== undefined) setGoalCompleted(detail.goals_completion);
    };

    window.addEventListener("duno-completion-updated", handleCompletionUpdate);
    return () => window.removeEventListener("duno-completion-updated", handleCompletionUpdate);
  }, []);

  const hasActiveNotifications = notificationList && notificationList.some(n => n.status === "active");

  const getInitials = (name) => {
    if (!name) return '';

    const nameParts = name.trim().split(' ');

    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    } else {
      // If two or more names, return the first letter of the first two names
      return nameParts[0].charAt(0).toUpperCase() + nameParts[1].charAt(0).toUpperCase();
    }
  };

  const userInitials = getInitials(UserName);

  useEffect(() => {
    try {
      const cached = JSON.parse(localStorage.getItem("profileImageSyncData") || "{}");
      if (cached.user_id && String(cached.user_id) !== String(UserID)) {
        localStorage.removeItem("profileImageSyncData");
      } else if (cached.profile_image) {
        setProfileImageUrl(withImageBust(cached.profile_image, cached.ts));
        setImageError(false);
      }
    } catch { }

    const handleProfileImageUpdate = (event) => {
      const detail = event?.detail || {};
      if (detail.user_id && String(detail.user_id) !== String(UserID)) return;
      if (detail.profile_image) {
        setProfileImageUrl(withImageBust(detail.profile_image, detail.ts));
        setImageError(false);
      }
    };

    window.addEventListener("duno-profile-image-updated", handleProfileImageUpdate);
    return () => window.removeEventListener("duno-profile-image-updated", handleProfileImageUpdate);
  }, []);

  const handleProfileNavigation = (e) => {
    e.stopPropagation();
    setProfilePopup(!profilePopup)
  };

  const handleMyAccountClick = () => {
    logActivity({ module: "PROFILE", action: "MY_ACCOUNT_CLICK", remark: "My Account from profile popup" });
    navigate("/profile/profile-details", { state: { userID: UserID } });
    setProfilePopup(false);
  };

  const handleNotificationClick = (e) => {
    e.stopPropagation();
    if (location.pathname === "/daily/drill" && !finished && timeRunning) {
      setFinishPopup(true);
    } else if (location.pathname === "/weekly/workout" && !finished && timeRunning) {
      setFinishPopup(true)
    } else {
      setNotificationPopUp(!notificationPopUp);
    }
  };



  const [isOpen, setIsOpen] = useState(false)

  const menu = [
    {
      id: 1,
      name: "Homepage",
      router: "/",
      icon: DashboardIcon,
      specialPaths: ["/daily/drill", "/weekly/workout"]
    },
    {
      id: 2,
      name: "Modules",
      router: "/new/learnings",
      icon: LearningIcon,
      specialPaths: ["/new/learnings/detail", "/assessments"]
    },
    {
      id: 3,
      name: "My Dashboard",
      router: "/performance",
      icon: PerformanceIcon
    },
    {
      id: 4,
      name: "My Profile",
      router: "/profile",
      icon: ProfileIcon
    },
    {
      id: 5,
      name: "My Subscription",
      router: "/subscribe/details",
      icon: BillingIcon
    },
    // {
    //     id:6,
    //     name:"Settings",
    //     router:"",
    //     icon:SettingsIcon
    // },
  ]

  const UserID = localStorage.getItem("USERID");
  const key = (() => { try { const v = localStorage.getItem("access-token"); return v && v !== "undefined" ? JSON.parse(v) : null; } catch { return null; } })();


  const dispatch = useDispatch();

  const [selectedMenu, setSelectedMenu] = useState({})
  const [logout, setLogout] = useState(false);

  const handleClick = (item) => {
    if (location.pathname === "/daily/drill" && !finished && timeRunning) {
      setFinishPopup(true)
    }
    else if (location.pathname === "/weekly/workout" && !finished && timeRunning) {
      setFinishPopup(true)
    }
    else {
      setSelectedMenu(item)
      navigate(item.router)
      setIsOpen(false);
    }
  }



  const handleLogout = (e) => {
    e.preventDefault();
    const isMentor = localStorage.getItem("mentor") === "true";
    logActivity({ module: "AUTH", action: "LOGOUT", remark: "User logged out" });
    localStorage.removeItem("access-token");
    localStorage.removeItem("ClubID");
    localStorage.removeItem("ORGID");
    localStorage.removeItem("USERID");
    localStorage.removeItem("mentor");
    localStorage.removeItem("roleId");
    localStorage.removeItem("learnertoken");
    localStorage.removeItem("learneruserid");
    localStorage.removeItem("username");
    localStorage.removeItem("newLearningId");
    localStorage.removeItem("MainLevelId");
    localStorage.removeItem("SubLevelId");
    localStorage.removeItem("clickedItem");
    localStorage.removeItem("clickeditemDes");
    localStorage.removeItem("functionCalled");
    localStorage.removeItem("rzp_checkout_anon_id");
    localStorage.removeItem("rzp_device_id");
    localStorage.removeItem("countrydetails");
    localStorage.removeItem("timezone");
    localStorage.removeItem("currency");
    localStorage.removeItem("adminmapped");
    localStorage.removeItem('dailySnoozeTriggered');
    localStorage.removeItem('weeklySnoozeTriggered');
    localStorage.removeItem('hasShownDailyDrill');
    localStorage.removeItem("trialUser")
    localStorage.removeItem("categoryID")
    googleLogout();
    navigate(isMentor ? "/login/mentor" : "/login");
    window.location.reload();
  };

  async function getNotification() {
    await fetch(`${baseurl}/notifications/user`, {
      method: "POST",
      body: JSON.stringify(
        {
          user_id: UserID,
          org_code: ""
        }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setNotificationList(data.data)
        }
        else {
          setNotificationList([])
        }
      });
  }

  async function notificationStatus(id) {
    await fetch(`${baseurl}/notification/status_change`, {
      method: "POST",
      body: JSON.stringify(
        {
          id: id,
        }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {

        }

      });
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setNotificationPopUp(false);
        setProfilePopup(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    const currentMenuItem = menu.find(item =>
      item.router === location.pathname ||
      (item.specialPaths && item.specialPaths.includes(location.pathname))
    );
    if (currentMenuItem) {
      setSelectedMenu(currentMenuItem);
    }
  }, [location.pathname]);


  // Fetch profile image
  useEffect(() => {
    const fetchProfileImage = async () => {
      if (UserID) {
        try {
          const response = await fetch(`${baseurl}/user/profile`, {
            method: "POST",
            body: JSON.stringify({ user_id: UserID, org_id: OrgID }),
            headers: {
              "Content-Type": "application/json",
            },
          });
          const data = await response.json();
          if (data.status === true && data.data && data.data.profile_image && data.data.profile_image.trim() !== "") {
            const imagePayload = { profile_image: data.data.profile_image, ts: Date.now(), user_id: String(UserID) };
            setProfileImageUrl(withImageBust(imagePayload.profile_image, imagePayload.ts));
            localStorage.setItem("profileImageSyncData", JSON.stringify(imagePayload));
            setImageError(false); // Reset error when new image URL is set
          } else {
            setProfileImageUrl("");
            setImageError(false);
          }
        } catch (error) {
          console.error("Error fetching profile image:", error);
          setProfileImageUrl("");
          setImageError(false);
        }
      } else {
        setProfileImageUrl("");
        setImageError(false);
      }
    };

    fetchProfileImage();
  }, [UserID, OrgID]);

  // Fetch profile & goals completion for circular progress rings
  useEffect(() => {
    const fetchCompletion = async () => {
      if (!UserID || !OrgID || !key) return;
      try {
        const response = await fetch(`${baseurl}/banner/data/retrive`, {
          method: "POST",
          body: JSON.stringify({ user_id: UserID, org_id: OrgID }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${key}`,
          },
        });
        const data = await response.json();
        if (data.status === true && data.data) {
          const completionPayload = {};
          if (data.data.profile_completion !== undefined) {
            setProfileCompleted(data.data.profile_completion);
            completionPayload.profile_completion = data.data.profile_completion;
          }
          if (data.data.goals_completion !== undefined) {
            setGoalCompleted(data.data.goals_completion);
            completionPayload.goals_completion = data.data.goals_completion;
          }
          if (Object.keys(completionPayload).length > 0) {
            localStorage.setItem("completionSyncData", JSON.stringify(completionPayload));
            window.dispatchEvent(new CustomEvent("duno-completion-updated", { detail: completionPayload }));
          }
        }
      } catch (err) {
        console.error("Error fetching completion:", err);
      }
    };
    fetchCompletion();
  }, [UserID, OrgID, key]);

  useEffect(() => {

    if (UserID) {
      const token = key; // Assuming `key` is the token
      dispatch(fetchUserDetails({ userid: UserID, token }));
      getNotification();
    } else {
      localStorage.removeItem("access-token");
      localStorage.removeItem("ClubID");
      localStorage.removeItem("ORGID");
      localStorage.removeItem("USERID");
      navigate("/login");
    }
  }, [UserID, dispatch, navigate, key]);



  const isAddSkillsPage = location.pathname === '/profile/add-skills';
  const isEditSkillsPage = location.pathname === '/profile/edit-skills';
  const isEditSkillPage = location.pathname === '/profile/edit-skill';
  const isSkillsPage = isAddSkillsPage || isEditSkillsPage || isEditSkillPage;

  const getHeaderTitle = () => {
    if (isAddSkillsPage) return 'Add Skills';
    if (isEditSkillsPage) return 'Edit Skills';
    if (isEditSkillPage) return 'Edit';
    return '';
  };

  const handleBackNavigation = () => {
    if (isEditSkillPage) {
      navigate('/profile/edit-skills');
    } else {
      navigate('/profile');
    }
  };

  return (
    <div className={style.Container}>
      {dashboardMode ? (
        <>
          <div className={style.dashboardTopRight}>
            <div className={style.userIconWrap} onClick={handleProfileNavigation}>
              <div className={style.userIcon}>
                <img
                  src={resolveProfileImageSrc()}
                  alt='user'
                  key={`header-profile-img-${UserID || 'none'}`}
                  onError={() => setImageError(true)}
                  onLoad={() => setImageError(false)}
                />
              </div>
              <svg className={style.progressRings} viewBox="0 0 52 52" aria-hidden="true">
                <defs>
                  <linearGradient id="igStoriesGradientComplete" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#0151CD" />
                    <stop offset="100%" stopColor="#7C3AED" />
                  </linearGradient>
                  <linearGradient id="igStoriesGradientZero" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#1e3a8a" />
                    <stop offset="100%" stopColor="#93c5fd" />
                  </linearGradient>
                </defs>
                <circle className={`${style.ringTrack} ${style.ringTrackOuter}`} cx="26" cy="26" r="24" />
                <circle
                  className={style.ringGoals}
                  cx="26" cy="26" r="24"
                  style={{
                    strokeDashoffset: (goalCompleted ?? 0) === 0 ? 0 : 151 * (1 - (goalCompleted ?? 0) / 100),
                    stroke: (goalCompleted ?? 0) >= 100 ? "url(#igStoriesGradientComplete)" : "url(#igStoriesGradientZero)",
                  }}
                />
                <circle className={`${style.ringTrack} ${style.ringTrackInner}`} cx="26" cy="26" r="21.5" />
                <circle
                  className={style.ringProfile}
                  cx="26" cy="26" r="21.5"
                  style={{
                    strokeDashoffset: (profileCompleted ?? 0) === 0 ? 0 : 135 * (1 - (profileCompleted ?? 0) / 100),
                    stroke: (profileCompleted ?? 0) >= 100 ? "url(#igStoriesGradientComplete)" : "url(#igStoriesGradientZero)",
                  }}
                />
              </svg>
            </div>
          </div>
          {!profileSlot && (
            <div className={style.dashboardMobileProfile}>
              <div className={style.userIconWrap} onClick={handleProfileNavigation}>
                <div className={style.userIcon}>
                  <img
                    src={resolveProfileImageSrc()}
                    alt='user'
                    key={`header-profile-img-mobile-${UserID || 'none'}`}
                    onError={() => setImageError(true)}
                    onLoad={() => setImageError(false)}
                  />
                </div>
                <svg className={style.progressRings} viewBox="0 0 52 52" aria-hidden="true">
                  <defs>
                    <linearGradient id="igStoriesGradientMobileComplete" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#0151CD" />
                      <stop offset="100%" stopColor="#7C3AED" />
                    </linearGradient>
                    <linearGradient id="igStoriesGradientMobileZero" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#1e3a8a" />
                      <stop offset="100%" stopColor="#93c5fd" />
                    </linearGradient>
                  </defs>
                  <circle className={`${style.ringTrack} ${style.ringTrackOuter}`} cx="26" cy="26" r="24" />
                  <circle
                    className={style.ringGoals}
                    cx="26" cy="26" r="24"
                    style={{
                      strokeDashoffset: (goalCompleted ?? 0) === 0 ? 0 : 151 * (1 - (goalCompleted ?? 0) / 100),
                      stroke: (goalCompleted ?? 0) >= 100 ? "url(#igStoriesGradientMobileComplete)" : "url(#igStoriesGradientMobileZero)",
                    }}
                  />
                  <circle className={`${style.ringTrack} ${style.ringTrackInner}`} cx="26" cy="26" r="21.5" />
                  <circle
                    className={style.ringProfile}
                    cx="26" cy="26" r="21.5"
                    style={{
                      strokeDashoffset: (profileCompleted ?? 0) === 0 ? 0 : 135 * (1 - (profileCompleted ?? 0) / 100),
                      stroke: (profileCompleted ?? 0) >= 100 ? "url(#igStoriesGradientMobileComplete)" : "url(#igStoriesGradientMobileZero)",
                    }}
                  />
                </svg>
              </div>
            </div>
          )}
          {profileSlot && dashboardMode && createPortal(
            <div className={style.userIconWrap} onClick={handleProfileNavigation}>
              <div className={style.userIcon}>
                <img
                  src={resolveProfileImageSrc()}
                  alt='user'
                  key={`header-profile-img-portal-${UserID || 'none'}`}
                  onError={() => setImageError(true)}
                  onLoad={() => setImageError(false)}
                />
              </div>
              <svg className={style.progressRings} viewBox="0 0 52 52" aria-hidden="true">
                <defs>
                  <linearGradient id="igStoriesGradientPortalComplete" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#0151CD" />
                    <stop offset="100%" stopColor="#7C3AED" />
                  </linearGradient>
                  <linearGradient id="igStoriesGradientPortalZero" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#1e3a8a" />
                    <stop offset="100%" stopColor="#93c5fd" />
                  </linearGradient>
                </defs>
                <circle className={`${style.ringTrack} ${style.ringTrackOuter}`} cx="26" cy="26" r="24" />
                <circle
                  className={style.ringGoals}
                  cx="26" cy="26" r="24"
                  style={{
                    strokeDashoffset: (goalCompleted ?? 0) === 0 ? 0 : 151 * (1 - (goalCompleted ?? 0) / 100),
                    stroke: (goalCompleted ?? 0) >= 100 ? "url(#igStoriesGradientPortalComplete)" : "url(#igStoriesGradientPortalZero)",
                  }}
                />
                <circle className={`${style.ringTrack} ${style.ringTrackInner}`} cx="26" cy="26" r="21.5" />
                <circle
                  className={style.ringProfile}
                  cx="26" cy="26" r="21.5"
                  style={{
                    strokeDashoffset: (profileCompleted ?? 0) === 0 ? 0 : 135 * (1 - (profileCompleted ?? 0) / 100),
                    stroke: (profileCompleted ?? 0) >= 100 ? "url(#igStoriesGradientPortalComplete)" : "url(#igStoriesGradientPortalZero)",
                  }}
                />
              </svg>
            </div>,
            profileSlot
          )}
        </>
      ) : (
        <div className={style.topBar}>
          {isSkillsPage ? (
            <div className={style.addSkillsHeader}>
              <button
                className={style.backButton}
                onClick={handleBackNavigation}
              >
                <MdArrowBack />
              </button>
              <h1 className={style.addSkillsTitle}>
                {getHeaderTitle()}
              </h1>
            </div>
          ) : (
            <>
              <div className={style.logoContainer}>
                <div className={style.menuIcon}>
                  <GiHamburgerMenu onClick={onMenuToggle || (() => setIsOpen(prevState => !prevState))} />
                </div>
                <img src={DunoLogo} alt="Duno Logo" />
              </div>
              <p className={style.greeting}>Good day{UserName ? `, ${UserName}` : ''}</p>
            </>
          )}
          <div className={style.topBarMenu}>
            {/* Notification icon commented out
            <div style={{ position: "relative" }} className={style.iconImage} onClick={handleNotificationClick}>
              <IoNotificationsOutline size={26} className={style.notificationIcon} />
              {hasActiveNotifications && <span className={style.notificationBadge}></span>}
            </div>
            */}
            <div className={style.userIconWrap} onClick={handleProfileNavigation}>
              <div className={style.userIcon}>
                <img
                  src={resolveProfileImageSrc()}
                  alt='user'
                  key={`header-profile-img-${UserID || 'none'}`}
                  onError={() => setImageError(true)}
                  onLoad={() => setImageError(false)}
                />
              </div>
              <svg className={style.progressRings} viewBox="0 0 52 52" aria-hidden="true">
                <defs>
                  <linearGradient id="igStoriesGradientTopBarComplete" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#0151CD" />
                    <stop offset="100%" stopColor="#7C3AED" />
                  </linearGradient>
                  <linearGradient id="igStoriesGradientTopBarZero" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#1e3a8a" />
                    <stop offset="100%" stopColor="#93c5fd" />
                  </linearGradient>
                </defs>
                <circle className={`${style.ringTrack} ${style.ringTrackOuter}`} cx="26" cy="26" r="24" />
                <circle
                  className={style.ringGoals}
                  cx="26" cy="26" r="24"
                  style={{
                    strokeDashoffset: (goalCompleted ?? 0) === 0 ? 0 : 151 * (1 - (goalCompleted ?? 0) / 100),
                    stroke: (goalCompleted ?? 0) >= 100 ? "url(#igStoriesGradientTopBarComplete)" : "url(#igStoriesGradientTopBarZero)",
                  }}
                />
                <circle className={`${style.ringTrack} ${style.ringTrackInner}`} cx="26" cy="26" r="21.5" />
                <circle
                  className={style.ringProfile}
                  cx="26" cy="26" r="21.5"
                  style={{
                    strokeDashoffset: (profileCompleted ?? 0) === 0 ? 0 : 135 * (1 - (profileCompleted ?? 0) / 100),
                    stroke: (profileCompleted ?? 0) >= 100 ? "url(#igStoriesGradientTopBarComplete)" : "url(#igStoriesGradientTopBarZero)",
                  }}
                />
              </svg>
            </div>
          </div>
        </div>
      )}
      {profilePopup && (
        <div ref={popupRef} className={style.profilePopup}>
          <div
            className={`${style.profilePopupSection} ${style.profilePopupSectionClickable}`}
            onClick={() => {
              logActivity({ module: "PROFILE", action: "PROFILE_COMPLETION_CLICK", remark: "Profile Edit from profile popup" });
              navigate("/profile");
              setProfilePopup(false);
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === "Enter") { navigate("/profile"); setProfilePopup(false); } }}
          >
            <h4 className={style.profilePopupSectionTitle}>Profile Completion</h4>
            <div className={style.profilePopupProgressRow}>
              <span className={style.profilePopupLabel}>Profile</span>
              <span className={style.profilePopupPercent}>{profileCompleted ?? 0}%</span>
            </div>
            <div className={style.profilePopupBar}>
              <div
                className={style.profilePopupBarFill}
                style={{
                  width: `${profileCompleted ?? 0}%`,
                  background: (profileCompleted ?? 0) >= 100 ? "linear-gradient(90deg, #0151CD, #7C3AED)" : "linear-gradient(90deg, #1e3a8a, #93c5fd)",
                }}
              />
            </div>
            <span
              className={style.profilePopupStatus}
              style={{
                color: (profileCompleted ?? 0) >= 100 ? "#7C3AED" : "#1e3a8a",
                background: (profileCompleted ?? 0) >= 100 ? "linear-gradient(135deg, rgba(1, 81, 205, 0.2) 0%, rgba(124, 58, 237, 0.2) 100%)" : "linear-gradient(135deg, rgba(30, 58, 138, 0.2) 0%, rgba(147, 197, 253, 0.3) 100%)",
              }}
            >
              {(profileCompleted ?? 0) >= 100 ? "Complete" : (profileCompleted ?? 0) === 0 ? "Not started" : `${profileCompleted ?? 0}% Completed`}
            </span>
            <button
              className={style.profilePopupUpdateBtn}
              onClick={(e) => {
                e.stopPropagation();
                logActivity({ module: "PROFILE", action: "PROFILE_COMPLETION_CLICK", remark: "Update profile from popup button" });
                navigate("/profile");
                setProfilePopup(false);
              }}
              type="button"
            >
              Update Profile
            </button>
          </div>
          <div
            className={`${style.profilePopupSection} ${style.profilePopupSectionClickable}`}
            onClick={() => {
              logActivity({ module: "PROFILE", action: "GOALS_PROGRESS_CLICK", remark: "Goal Setting from profile popup" });
              navigate("/profile", { state: { openGoalsPopup: true } });
              setProfilePopup(false);
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === "Enter") { navigate("/profile", { state: { openGoalsPopup: true } }); setProfilePopup(false); } }}
          >
            <h4 className={style.profilePopupSectionTitle}>Goals Progress</h4>
            <div className={style.profilePopupProgressRow}>
              <span className={style.profilePopupLabel}>Goals</span>
              <span className={style.profilePopupPercent}>{goalCompleted ?? 0}%</span>
            </div>
            <div className={style.profilePopupBar}>
              <div
                className={style.profilePopupBarFill}
                style={{
                  width: `${goalCompleted ?? 0}%`,
                  background: (goalCompleted ?? 0) >= 100 ? "linear-gradient(90deg, #0151CD, #7C3AED)" : "linear-gradient(90deg, #1e3a8a, #93c5fd)",
                }}
              />
            </div>
            <span
              className={style.profilePopupStatus}
              style={{
                color: (goalCompleted ?? 0) >= 100 ? "#7C3AED" : "#1e3a8a",
                background: (goalCompleted ?? 0) >= 100 ? "linear-gradient(135deg, rgba(1, 81, 205, 0.2) 0%, rgba(124, 58, 237, 0.2) 100%)" : "linear-gradient(135deg, rgba(30, 58, 138, 0.2) 0%, rgba(147, 197, 253, 0.3) 100%)",
              }}
            >
              {(goalCompleted ?? 0) >= 100 ? "Complete" : (goalCompleted ?? 0) === 0 ? "Not started" : `${goalCompleted ?? 0}% Completed`}
            </span>
            <button
              className={style.profilePopupUpdateBtn}
              onClick={(e) => {
                e.stopPropagation();
                logActivity({ module: "PROFILE", action: "GOALS_PROGRESS_CLICK", remark: "Update goals from popup button" });
                navigate("/profile", { state: { openGoalsPopup: true } });
                setProfilePopup(false);
              }}
              type="button"
            >
              Update Career Goals
            </button>
          </div>
          <div className={style.profilePopupDivider} />
          <div className={style.profilePopupItem} onClick={handleMyAccountClick}>
            <div className={style.profilePopupIcon}><MdPerson size={20} /></div>
            <p>My Account</p>
          </div>
          <div
            className={style.profilePopupItem}
            onClick={() => {
              logActivity({ module: "PROFILE", action: "MY_SUBSCRIPTION_CLICK", remark: "My Subscription from profile popup" });
              navigate("/subscribe/details");
              setProfilePopup(false);
            }}
          >
            <div className={style.profilePopupIcon}><MdCardMembership size={20} /></div>
            <p>My Subscription</p>
          </div>
          <div className={style.profilePopupItem} onClick={() => {
            logActivity({ module: "PROFILE", action: "LOGOUT_CLICK", remark: "Logout initiated from profile popup" });
            setLogout(true);
            setProfilePopup(false);
          }}>
            <div className={style.profilePopupIcon}><MdLogout size={20} /></div>
            <p>Logout</p>
          </div>
        </div>
      )}
      {notificationPopUp && (
        <div ref={popupRef} className={style.notificationPopUp}>
          <div className={style.notificationHeader}>
            <p>Notifications</p>
          </div>
          <div className={style.notificationContent}>
            {notificationList && notificationList.length > 0 ? notificationList.map((notification, i) => (
              <div key={i} className={style.notificationItemContainer} style={{ background: notification.status === "active" ? "White" : "#d9d9d98c" }}>
                <div className={style.notificationItem} onClick={() => {
                  if (notification.status === "active") {
                    notificationStatus(notification._id)
                    if (notification.type === "Subscription") {
                      navigate("/subscribe/details")
                    }
                  }
                }}>
                  <div className={style.notificationItemLeft}>
                    <div className={style.notificationLeftImage}><img src={notification.image} alt="" /></div>
                  </div>
                  <div className={style.notificationItemRight}>
                    <div className={style.notificationRightHeader}>
                      <p>{notification.type}</p>
                    </div>
                    <div className={style.notificationRightContent}>
                      <p>{notification.title}</p>
                      <span>{notification.description}</span>
                    </div>
                    <div className={style.notificationRightBottom}>
                      <p>{notification.time}</p>
                    </div>
                  </div>
                </div>
              </div>

            )) : "No Notification"}




          </div>
        </div>
      )}
      {isOpen ? (
        <>
          <div className={style.sidebar}>
            <div className={style.MenuContainer}>
              {menu.map((item) => {
                return (
                  <div onClick={() => {
                    handleClick(item)
                  }} key={item.id} className={selectedMenu.id === item.id ? style.selectedMenu : style.menuItem}>
                    <div className={style.menuItemImage}><img src={item.icon} alt={item.name} /></div>
                    <div className={style.menuItemText}><p>{item.name}</p></div>
                  </div>
                )
              })}

            </div>
            <div className={style.bottomContent}>
              <div className={style.separateLine}></div>
              <div className={selectedMenu.id === 7 ? style.selectedBottomText : style.bottomText}>
                <p onClick={() => {
                  handleClick({
                    id: 7,
                    name: "Support",
                    router: "/support",

                  })
                }} className={style.supportText}>FAQs and Help</p>
              </div>
            </div>


          </div>
        </>
      ) : (
        ""
      )}

      {logout ? (
        <>
          <div className={style.popupOverlay} onClick={() => setLogout(false)}></div>
          <div className={style.Popup}>
            <div className={style.popupIconArea}>
              <FiLogOut />
            </div>
            <div className={style.popupText}>
              <p>Log out of Duno?</p>
              <span>You'll need to sign in again to access your account.</span>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.noButton}
                onClick={() => {
                  setLogout(false);
                }}
              >
                Stay
              </button>
              <button
                className={style.yesButton}
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout(e);
                }}
              >
                Log out
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {sessionExpired ? (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            <div className={style.popupIconArea}>
              <FiLogOut />
            </div>
            <div className={style.popupText}>
              <p>Session Expired</p>
              <span>Your session has expired. Please log in again to continue.</span>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.noButton}
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout(e);
                }}
              >
                Login Again
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  )
}

export default InnerHeadBar